type SubmitSamlFormProps = {
    /** The SAML response context */
    context: string;
    /** The endpoint URL where the SAML form will be submitted */
    endpoint: string;
};

/**
 * Submits a SAML form with the provided response context to the specified endpoint.
 * @param props The SAML form submission properties
 * @throws Error if the form submission fails or if required parameters are invalid
 */
export function submitSamlForm({ endpoint, context }: SubmitSamlFormProps): void {
    if (!endpoint || !context) {
        throw new Error('SAML form submission requires both endpoint and context parameters');
    }

    if (!endpoint.startsWith('http://') && !endpoint.startsWith('https://')) {
        throw new Error('SAML endpoint must be a valid HTTP(S) URL');
    }

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = endpoint;
    form.target = '_blank';
    form.style.display = 'none';

    try {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'SAMLResponse';
        input.value = context;
        form.appendChild(input);

        document.body.appendChild(form);
        form.submit();
    } catch (error) {
        throw new Error(`Failed to submit SAML form: ${error instanceof Error ? error.message : 'Unknown error'}`);
    } finally {
        if (form.parentNode) {
            form.parentNode.removeChild(form);
        }
    }
}
